import React from "react";

import { Box, SvgIconProps, Typography } from "@mui/material";
import MuiMenuItem from "@mui/material/MenuItem";
import styled from "@mui/material/styles/styled";

import Link, { LinkProps } from "@app/common/components/Link";

import { Row } from "@rui/Stack";

import SideNavButtonIcon from "./SideNavButtonIcon";

const MenuItemLink = styled(Link)(({ theme }) => ({
  color: theme.palette.shades.neutral[800],
  height: "fit-content",
  width: "100%",
}));

const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
  ...theme.typography.bodySecondaryMed,
  backgroundColor: "transparent",
  borderRadius: theme.corners.base,
  padding: theme.spacing(1),
  minHeight: 0,
  width: "100%",
  "&.Mui-focusVisible": {
    backgroundColor: "transparent",
  },
  "&:hover": {
    backgroundColor: "#F1F4FF",
  },
}));

interface SideNavMenuItemProps extends LinkProps {
  Icon: React.FunctionComponent<SvgIconProps>;
}

const SideNavMenuItem = ({
  Icon,
  children,
  ...props
}: SideNavMenuItemProps) => {
  return (
    <MenuItemLink {...props}>
      <MenuItem>
        <Row variant="left" spacing={1}>
          <Box sx={{ color: "shades.neutral.400" }}>
            <SideNavButtonIcon Icon={Icon} />
          </Box>
          <Row variant="left" spacing={0.5}>
            <Typography variant="bodySecondaryMed" noWrap>
              {children}
            </Typography>
          </Row>
        </Row>
      </MenuItem>
    </MenuItemLink>
  );
};

export default SideNavMenuItem;
